<template>
  <DefaultLayout class="ChartView">
    <h1 class="mb-4 display-1">
      Диаграмма событий
    </h1>
    <VAlert
      v-if="!authorized"
      border="left"
      outlined
      color="primary"
      icon="mdi-account-circle"
    >
      Для просмотра событий требуется
      <VBtn
        text
        small
        color="primary"
        @click="$store.commit('ui/setLoginModal', { value: true })"
      >
        авторизоваться
      </VBtn>
    </VAlert>
    <template v-if="authorized">
      <VRow>
        <VCol
          cols="12"
          sm="6"
          md="4"
        >
          <DatePicker
            :is-open.sync="ui.dtMenuIsOpen"
            block
            range
            :value="dtFiltersIsoRange"
            :max="today()"
            @input="dtInput($event)"
          />
        </VCol>
        <VCol
          v-if="events != null && events.length < eventsTotal"
          cols="12"
          sm="auto"
        >
          <VAlert
            border="left"
            outlined
            :color="company && company.isPremium ? 'primary' : 'warning'"
            icon="mdi-cloud-alert"
          >
            <template v-if="company && company.isPremium">
              Показаны первые
              {{ events.length }}/{{ eventsTotal }} событий
              <VBtn
                text
                small
                color="secondary"
                :disabled="loading"
                @click="getMoreEvents()"
              >
                загрузить еще {{ moreLimit }}
              </VBtn>
            </template>
            <template v-else-if="company">
              В бесплатной версии отображается до {{ company.eventLimit }}
              событий на пользователя.
            </template>
          </VAlert>
        </VCol>
      </VRow>
      <EventChart
        user-quick-filter
        :title="`События ${dtFiltersTextDisplay}`"
        @reset-date="ui.dtMenuIsOpen = true"
        @reset-filters="resetFilters()"
      />
    </template>
  </DefaultLayout>
</template>

<script>
import moment from 'moment'
import * as R from 'ramda'

import EventChart from '../components/EventChart'
import DatePicker from '../components/DatePicker'
import DefaultLayout from '../layouts/Default'

const ISO_DATE = 'YYYY-MM-DD'
const toIsoDate = dt => moment(dt).format(ISO_DATE)
const PRETTY_DATE = 'll'
const toPrettyDate = dt => moment(dt).format(PRETTY_DATE)

const defaultFilters = () => {
  const now = moment()
  return ({
    dtStart: now.startOf('day').toISOString(),
    dtEnd: now.endOf('day').toISOString(),
  })
}

export default {
  name: 'Chart',
  components: {
    DatePicker,
    DefaultLayout,
    EventChart,
  },
  data() {
    return {
      ui: {
        // серверная фильтрация
        filters: defaultFilters(),
        dtMenuIsOpen: false,
      },
    }
  },
  computed: {
    authorized() { return !!this.$store.state.auth.token },
    events() { return this.$store.getters['event/events'] }, // События для чарта
    eventsTotal() { return this.$store.state.event.total }, // N событий на чарте
    loading() { return this.$store.state.event.loading }, // N событий на чарте
    limit() { return this.$store.state.event.MAX_RECORDS },
    moreLimit() { return this.$store.state.event.LOAD_MORE_RECORDS },
    company() { return this.$store.state.company.current },
    dtFiltersIsoRange() {
      return [this.ui.filters.dtStart, this.ui.filters.dtEnd].map(toIsoDate)
    },
    dtFiltersTextDisplay() {
      const [start, end] = this.dtFiltersIsoRange
      return start === end
        ? toPrettyDate(start)
        : [start, end].map(toPrettyDate).join(' — ')
    },
  },
  watch: {
    authorized: {
      handler(isAuthorized, wasAuthorized) {
        if (isAuthorized && !wasAuthorized) { this.getEvents() }
      },
      immediate: true,
    },
    'ui.filters': {
      handler() {
        if (this.authorized) { this.getEvents() }
      },
      deep: true,
    },
  },
  methods: {
    getEvents() {
      const {
        $store,
        limit,
        ui: { filters: filter },
      } = this
      return $store.dispatch('event/getList', { filter, limit })
    },
    getMoreEvents() {
      const {
        $store,
        moreLimit: limit,
        events,
        ui: { filters: filter },
      } = this
      return $store.dispatch('event/getList', {
        filter,
        limit,
        offset: events.length,
      })
    },
    resetFilters() {
      this.ui.filters = defaultFilters()
    },
    dtInput(selection) {
      const [start, end] = R.pipe(
        R.sortBy(R.identity),
        R.map(date => moment(date))
      )(selection)
      this.ui.filters.dtStart = start.format('YYYY-MM-DD')
      this.ui.filters.dtEnd = end.format('YYYY-MM-DD')
    },
    today() { return moment().format(ISO_DATE) },
  },
}
</script>
